/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';

export default Construct.extend({
    createCookie: function (name, value, date, domain) {
        date = new Date(date);
        date = date.toUTCString();
        document.cookie = name + '=' + value + '; path=/; expires=' + date + (domain ? ';domain=' + domain : '');
    },

    deleteCookie: function (name, domain) {
        var date = new Date();
        date.setDate(date.getDate() - 1);
        date = date.toUTCString();
        document.cookie = name + '=; path=/; expires=' + date + (domain ? ';domain=' + domain : '');
    },

    getCookie: function (name) {
        var matches = document.cookie.match(new RegExp('(?:^|; )' +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    getDomain: function (partsNum) {
        var host = document.location.host;
        var hostParts = host.split('.');
        if (partsNum) {
            return '.' + hostParts.slice(-partsNum).join('.');
        } else {
            return host;
        }
    }
}, {});
